import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Modal, Button, Row, Col, Image } from "react-bootstrap";
import moment from "moment";
import axios from "axios";
import {
  TextField,
  // FormControl,
  // Select
} from "@material-ui/core";
// import classnames from "classnames";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import "react-responsive-modal/styles.css";
import ReactStars from "react-rating-stars-component";
// import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
// import { InputBoxComponent } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import InputNumberFunc from "../../../../../function/InputNumberFunc";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../store/actions/errorActions";
import {
  get_vendor_diners_information,
  add_review_for_vendor_side,
  get_all_admin_pending_vendors,
} from "../../../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";
import isEmpty from "../../../../../store/validation/is-Empty";
import { SuperAdminPendingRatingReview } from "../../../../../store/validation/allValidationFile/superAdminDashboardValidation/SuperAdminRatingReviewValidation";
// import store from "../../../../store/store";
// import { SET_VENDOR_TICKETS_USER_DETAILS } from "../../../../store/types";

const PendingAddRatingReview = (props) => {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    description: "",
    mobile_number: "",
    errors: {},
    error: null,
    isLoading: false,
    dinerID: "",
  });
  const [countryCode, setCountryCode] = useState("");
  const [rating, setRating] = useState(1);

  useEffect(() => {
    setState({ ...state, isLoading: true });
    axios
      .get("https://ipapi.co/json")
      .then((result) => setCountryCode(result.data.country_calling_code))
      .catch((error) =>
        setState({
          ...state,
          error,
          isLoading: false,
        })
      );
    props.clear_all_errors();
  }, []);

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  const [showView, setShowView] = useState(false);
  const handleShowView = () => setShowView(true);
  const handleCloseView = () => setShowView(false);

  const onChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
      errors: {},
    });
    clear_all_errors();
  };

  const onChangeNumber = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    setState({
      ...state,
      [e.target.name]: number,
      errors: {},
    });
  };

  const countryCodeChange = (e) => {
    setCountryCode(e.target.value);
    // clear_all_errors();
  };

  const ratingChanged = (newRating) => {
    setRating(newRating);
  };

  const onGetData = (mobile_number) => (e) => {
    if (mobile_number.length > 9) {
      const vendorId = props.data.vendor_id;
      const token = props.auth.user.accessToken;
      props.get_vendor_diners_information(
        vendorId,
        countryCode,
        mobile_number,
        token,
        "phone"
      );
      props.clear_all_errors();
    }
    props.clear_all_errors();
  };

  // const dinerInfo = useSelector((state) => {
  //   return !isEmpty(state.adminAllVendorsInfo.superAdminDinersInfo)
  //     ? state.adminAllVendorsInfo.superAdminDinersInfo.diners
  //     : null;
  // });
  const token = useSelector((state) => {
    return !isEmpty(state.auth.user) ? state.auth.user.accessToken : null;
  });

  // const [selectedTab, setSelectedTab] = useState(0);

  // const handleTab = (e) => {
  //   setSelectedTab(e);
  // };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { errors, isValid } = SuperAdminPendingRatingReview(state);
    if (!isValid) {
      setState({
        ...state,
        errors: errors,
      });
    } else {
      const tokenData = token;
      const formData = {
        // diner_id: state.dinerID,
        review: state.description,
        rating: rating,
        // mobile: countryCode + state.mobile_number,
        mobile: state.mobile_number,
        country_code: countryCode,
        request_time: moment().valueOf(),
        vendor_id: props.data.vendor_id,
        restaurant_id: props.data._id,
        type: 0,
      };
      // console.log(tokenData, formData);
      dispatch(add_review_for_vendor_side(formData, tokenData, onSuccess));
    }
  };

  const onSuccess = (e) => {
    dispatch(get_all_admin_pending_vendors(token));
    handleCloseView();
  };

  return (
    <div>
      {/* <Button
        variant="danger"
        className="btn btn-danger btn2 btn-lg"
        onClick={handleShowView}
      >
        + Add Review
      </Button> */}
      <Button
        variant="link"
        className="enIconBtn mr-3 action_icon_padding"
        onClick={handleShowView}
      >
        <Image
          src={require("../../../../../assets/images/ActionImages/image/rating.svg")}
          alt="Rating"
          title="Rating"
          fluid
        />
      </Button>
      <Modal
        show={showView}
        onHide={handleCloseView}
        centered
        size="lg"
        className="modalAddReview"
      >
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f18-700">Add Review</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <div className="icon-add-body-section">
            <Form noValidate onSubmit={handleSubmit}>
              <div className="d-flex justify-content-between">
                <div className="f16-500">
                  Date: {moment().format("DD-MM-YYYY")}
                </div>
                <div className="f16-500">
                  Time: {moment().format("HH:mm:ss A")}
                </div>
              </div>
              <hr />
              <div className="f16-700">
                Restaurant Name: &nbsp;
                <span>{props.data.restaurant_name}</span>
              </div>
              <hr />
              {/* <div className="icon-add-body-section-boxone">
                <div className="12-500">Review Comments</div>
              </div> */}
              <TextField
                multiline
                rows={5}
                label="Review Comment"
                id="outlined-basic"
                variant="outlined"
                className="w-100"
                onChange={onChange}
                name="description"
                value={state.description}
                error={state.errors && state.errors.description ? true : false}
                helperText={state.errors && state.errors.description}
              />
              <div className="form-group star-reating-review">
                <div className="icon-add-body-section-boxone">
                  <div className="f14-500 mt-3">Select Rating</div>
                  <div className="w-100">
                    <ReactStars
                      count={5}
                      value={rating}
                      onChange={ratingChanged}
                      size={60}
                      half={true}
                      emptyIcon={<i className="far fa-star"></i>}
                      halfIcon={<i className="fa fa-star-half-alt"></i>}
                      fullIcon={<i className="fa fa-star"></i>}
                      color1={"#E8E8E8"}
                      color2={"#FDD400"}
                    />
                  </div>
                </div>
                <div className="icon-add-body-section-boxone mt-3">
                  <Row>
                    <Col lg={4} className="d-flex align-items-center">
                      <div className="f14-700 mb-1">Reviewers User ID</div>
                    </Col>
                    <Col lg={6}>
                      <Form.Group className="d-flex align-items-center">
                        {/* <Form.Group
                          className="reusableInputComponent-main mb-0"
                          controlId={"country_code"}
                        > */}
                        <div
                          className="input-phone-country-code-reusable mr-3"
                          style={{ width: "40%" }}
                        >
                          <select
                            className="w-100"
                            name="countryCode"
                            value={countryCode}
                            onChange={countryCodeChange}
                          >
                            {getCountries().map(
                              (country) =>
                                countryCode !==
                                  "+" + getCountryCallingCode(country) && (
                                  <option
                                    key={country}
                                    value={"+" + getCountryCallingCode(country)}
                                  >
                                    {en[country]} (+
                                    {getCountryCallingCode(country)})
                                  </option>
                                )
                            )}
                            <option value={countryCode}>{countryCode}</option>
                          </select>
                        </div>
                        {/* <FormControl
                          variant="outlined"
                          className="enCountryCode mr-3"
                        >
                          <Select
                            name="countryCode"
                            value={countryCode}
                            onChange={countryCodeChange}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            <option value={countryCode}>{countryCode}</option>
                            {getCountries().map((country) => (
                              <option
                                key={country}
                                value={"+" + getCountryCallingCode(country)}
                              >
                                {en[country]} (+
                                {getCountryCallingCode(country)})
                              </option>
                            ))}
                          </Select>
                        </FormControl> */}
                        <TextField
                          id="outlined-basic"
                          placeholder="Enter mobile number"
                          variant="outlined"
                          className="w-100"
                          value={state.mobile_number}
                          onChange={onChangeNumber}
                          type="number"
                          onKeyDown={InputNumberFunc}
                          onKeyUp={onGetData(state.mobile_number)}
                          inputProps={{
                            name: "mobile_number",
                            maxLength: 10,
                          }}
                          // error={
                          //   state.errors && state.errors.mobile_number
                          //     ? true
                          //     : false
                          // }
                          // helperText={
                          //   state.errors && state.errors.mobile_number
                          // }
                        />
                      </Form.Group>
                      <div className="row">
                        <div className="col-md-4"></div>
                        <div className="col-md-8 p-0">
                          <div className="f12-400 text-red">
                            {state.errors && state.errors.mobile_number}
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <Button
                  variant="outline-secondary"
                  className="mr-4 px-5 py-2"
                  onClick={handleCloseView}
                >
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  className="f18-500 px-5 py-2"
                  type="submit"
                >
                  Submit
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

PendingAddRatingReview.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  getDetailsInfo: state.allDinerDetails.set_vendor_tickets_user_details,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  get_vendor_diners_information,
  add_review_for_vendor_side,
  get_all_admin_pending_vendors,
})(withRouter(PendingAddRatingReview));
